import React, { useState, useEffect, useContext, useRef } from 'react';
import { Badge, Container, Form, Stack } from 'react-bootstrap';
import classNames from 'classnames';
import _ from 'lodash';
import classes from './Header.module.scss';
import { DimensionContext, Button, Icon } from 'lb-components';
import { Api, useTranslation } from 'lb-store';
import { UseLang, UseNavigation, UseUser } from 'lb-store/src/hooks';
import { Toast } from 'lb-store';
import Moment from 'moment';
import {
  BalanceIcon,
  LargeLogoIcon,
  MarketIcon,
  NewsIcon,
  CurrentPromoIcon,
  SmallLogoIcon,
  UserIcon,
  ArrowDown,
  BellIcon,
  SuccessIconFill,
  CashbackHeaderIcon,
  UserMenuIcons,
  RegisterBonus,
  PromoPorsche,
} from '../../assets/icons';
import {
  CashInIcon,
  LockIcon,
  TicketHistoryIcon,
} from '../../assets/icons/menu';
import { GeorgiaFlag, RussiaFlag, UkFlag } from '../../assets/icons/flags';

import { CSSTransition } from 'react-transition-group';

import Placeholder from './Placeholder';
import { AuthContainer } from './AuthContainer';
import { Link } from 'react-router-dom';
import PromoTooltip from '../PromoTooltip/PromoTooltip';

const flags = {
  ka: GeorgiaFlag,
  ru: RussiaFlag,
  en: UkFlag,
};
const tooltipMenu = [
  { label: 'ბალანსის მართვა', to: '/user/manage-balance', icon: CashInIcon },
  { label: 'შეტყობინებები', to: '/user/notifications', icon: BellIcon },
  { label: 'პაროლის შეცვლა', to: '/user/password-reset', icon: LockIcon },
  { label: 'უსაფრთხოება', to: '/user/security-options', icon: LockIcon },
  {
    label: 'ბილეთების ისტორია',
    to: '/user/ticket-history',
    icon: TicketHistoryIcon,
  },
];

window.showBalance = null;
const Header = () => {
  const langHook = UseLang();
  const { t, i18n } = useTranslation();
  const { clientWidth, size } = useContext(DimensionContext);
  const { User, logout, updateBalance } = UseUser();
  const nav = UseNavigation();
  const [loading, setLoading] = useState(false);
  const [showSafeAmount, setShowSafeAmount] = useState(false);
  const [levelData, setLevelData] = useState();
  const [currentPromoData, setCurrentPromoData] = useState();

  const [showPinMessage, setShowPinMessage] = useState();
  const pinMessageRef = useRef();

  useEffect(() => {
    if (User.isLogged) {
      Api.User.Level().then((res) => {
        if (res.status && res.data?.status === 1) {
          setLevelData({
            /*value: res.data.levelData.value,*/
            percent: res.data.levelData.bar2,
            level: res.data.levelData.level,
            /*active: res.data.levelData.active,
            bar: res.data.levelData.bar,*/
            points: res.data.levelData.points,
          });
        }
      });
      /*Api.User.Promotions().then((res) => {
        if (res.status && res.data?.status === 1) {
          setCurrentPromoData(
            _.find(res.data?.data, (v, k) => {
              const [startDate, endDate] = k.split(':');
              return Moment().isBetween(Moment(startDate), Moment(endDate));
            }) || {}
          );
        }
      });*/
    }
  }, [User.isLogged]);

  return (
    <Container fluid={'gigantic'} className={classes.headerContainer}>
      <header className={classes.header}>
        <Link
          to={'/'.concat(i18n.language)}
          className={classes.logo}
          onClick={(e) => {
            if (e.ctrlKey) return;
            e.preventDefault();
            nav.navigate('/'.concat(i18n.language));
          }}
        >
          <img
            src={clientWidth < 1005 ? SmallLogoIcon : LargeLogoIcon}
            alt={'logo'}
            width={'100%'}
            height={'100%'}
          />
        </Link>
        <section className={classes.promo}>
          {/*<div onClick={() => nav.navigate('/')} className={classes.local}>
            <Icon
              Icon={RaffleIcon}
              width={'10rem'}
              height={'4.8rem'}
              native={true}
            />
          </div>*/}
          {User.isLogged !== undefined && User?.data && !User.data?.branch && (
            <>
              <Link
                to={'/'.concat(i18n.language || 'ka', '/page/betmarket')}
                onClick={(e) => {
                  if (e.ctrlKey) return;
                  e.preventDefault();
                  nav.navigate(
                    '/'.concat(i18n.language || 'ka', '/page/betmarket')
                  );
                }}
              >
                <div className={classes.market}>
                  <Icon
                    Icon={MarketIcon}
                    width={'2rem'}
                    height={'2rem'}
                    native={true}
                  />
                  <span style={{ marginLeft: '10px' }}>{t('ბეთმარკეტი')}</span>
                </div>
              </Link>
              <Link
                to={'/'.concat(i18n.language || 'ka', '/news')}
                onClick={(e) => {
                  if (e.ctrlKey) return;
                  e.preventDefault();
                  nav.navigate('/'.concat(i18n.language || 'ka', '/news'));
                }}
              >
                <div className={classes.news}>
                  <Icon
                    Icon={NewsIcon}
                    width={'2rem'}
                    height={'2rem'}
                    native={true}
                  />
                  <span style={{ marginLeft: '10px' }}>{t('აქციები')}</span>
                </div>
              </Link>
            </>
          )}

          {/*<Icon
            Icon={PromoPorsche}
            classname={classes.currPromo}
            onClick={() =>
              nav.navigate(`/${i18n.language}/promotions/wonderland`)
            }
          />*/}
          {/*{currentPromoData && (
            <div>
              <PromoTooltip data={currentPromoData} />
            </div>
          )}*/}
        </section>
        <div className={classes.right}>
          {loading || User.isLogged === null ? (
            <Placeholder />
          ) : User.isLogged ? (
            <section className={classes.user}>
              <div className={classes.userInfoContainer}>
                <Link
                  to={'/user/notifications'}
                  className={classes.notifications}
                  onClick={(e) => {
                    if (e.ctrlKey) return;
                    e.preventDefault();
                    nav.navigate(`/${i18n.language}/user/notifications`);
                  }}
                >
                  <Icon Icon={BellIcon} height={'3.5rem'} width={'1.8rem'} />
                  {User.notifications > 0 && (
                    <Badge bg={'danger'} className={classes.badge}>
                      {User.notifications}
                    </Badge>
                  )}
                </Link>
                {/*<div className={classes.userAccount}></div>*/}
                <div
                  className={classes.status}
                  onClick={() =>
                    nav.navigate(`/${i18n.language}/user/manage-balance`)
                  }
                >
                  <Icon
                    Icon={CashbackHeaderIcon}
                    style={{
                      height: '24px',
                      width: '24px',
                      backgroundSize: '24px',
                      backgroundPosition: `0px -${
                        (parseInt(levelData?.level) - 1) * 24
                      }px`,
                    }}
                    classname={classes.statusIcon}
                  />
                  <span>{User.data.username}</span>
                  {/*<div className={classes.tooltip}>
                    <div className={classes.content}>
                      <div>
                        <Icon
                          style={{
                            height: '2rem',
                            width: '2rem',
                            backgroundPosition: `${
                              -20 * (parseInt(levelData?.level) - 1) - 1
                            }px -1px`,
                            backgroundSize: 'auto',
                          }}
                          Icon={CashbackIcons}
                        />
                        <div className={classes.progress}>
                          <div>
                            <div
                              className={classes.bar}
                              style={{ width: `${levelData?.percent}%` }}
                            >
                              <span>{levelData?.percent}%</span>
                            </div>
                          </div>
                          <span
                            className={classes.points}
                            style={{ marginLeft: `${levelData?.percent}%` }}
                          >
                            {levelData?.points} {t('ქულა')}
                          </span>
                        </div>
                        <Icon
                          style={{
                            height: '22px',
                            width: '65px',
                            backgroundPosition: '0 -22px',
                            backgroundSize: 'auto',
                          }}
                          Icon={
                            CashbackLevels[
                              levelData?.level === '5'
                                ? '5'
                                : parseInt(levelData?.level) + 1
                            ]
                          }
                        />
                      </div>
                      <Link
                        to={'/news/312'}
                        onClick={(e) => {
                          if (e.ctrlKey) return;
                          e.preventDefault();
                          nav.navigate('/news/312');
                        }}
                      >
                        {t('გაეცანით აქციის წესებს')}
                      </Link>
                    </div>
                  </div>*/}
                </div>
                <div
                  className={classes.pin}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigator.clipboard.writeText(User.data.pin).then(() => {
                      if (!showPinMessage) {
                        setShowPinMessage(true);
                        setTimeout(() => {
                          setShowPinMessage(false);
                        }, 2000);
                      }
                    });
                  }}
                >
                  <div className={classes.pinIcon}>PIN</div>
                  <span>{User.data.pin}</span>
                  <CSSTransition
                    in={showPinMessage}
                    timeout={300}
                    unmountOnExit
                    classNames={{
                      enter: classes.enter,
                      enterActive: classes.enterActive,
                      enterDone: classes.enterDone,
                      exit: classes.exit,
                      exitActive: classes.exitActive,
                    }}
                    nodeRef={pinMessageRef}
                  >
                    <div className={classes.message} ref={pinMessageRef}>
                      <Icon
                        type={'vec'}
                        Icon={SuccessIconFill}
                        style={{
                          height: '1.8rem',
                          width: '1.8rem',
                          backgroundColor: '#fff',
                        }}
                      />
                      <span>{t('პინ კოდი დაკოპირებულია')}</span>
                    </div>
                  </CSSTransition>
                </div>

                <div className={classes.safe}>
                  <span
                    className={classNames(
                      classes.safeAmount,
                      !showSafeAmount ? classes.hide : null
                    )}
                  >
                    {User.balance.balance}
                  </span>
                  <Form.Check
                    type='switch'
                    className={classes.safeSwitch}
                    id={classes.safeSwitchId}
                    checked={showSafeAmount}
                    onChange={() => {
                      updateBalance(true).then(() => {
                        if (!showSafeAmount) {
                          window.showBalance = setTimeout(() => {
                            setShowSafeAmount(false);
                          }, 10000);
                        } else {
                          clearTimeout(window.showBalance);
                        }
                        setShowSafeAmount(!showSafeAmount);
                      });

                      /* localStorage.setItem(
                         'showBalance',
                         (!showSafeAmount).toString()
                       );*/
                    }}
                  />
                </div>
              </div>
              <Link to={'/user/deposit'}>
                <Button
                  variant={'success'}
                  onClick={(e) => {
                    if (e.ctrlKey) return;
                    e.preventDefault();
                    nav.navigate('/user/deposit');
                  }}
                >
                  {clientWidth < 888 ? (
                    <Icon
                      Icon={BalanceIcon}
                      native={true}
                      width={'20px'}
                      height={'24px'}
                    />
                  ) : clientWidth > 1340 ? (
                    t('ბალანსის შევსება')
                  ) : (
                    t('შევსება')
                  )}
                </Button>
              </Link>
              <Link to={'/user'}>
                <Button
                  style={{ margin: '0 1rem' }}
                  variant={clientWidth < 888 ? 'secondary' : 'primary'}
                  onClick={(e) => {
                    if (e.ctrlKey) return;
                    e.preventDefault();
                    nav.navigate('/user');
                  }}
                >
                  {clientWidth < 888 ? (
                    <Icon Icon={UserIcon} width={'20px'} height={'24px'} />
                  ) : clientWidth > 1240 ? (
                    t('ჩემი ანგარიში')
                  ) : (
                    t('ანგარიში')
                  )}
                </Button>
              </Link>

              <div className={classes.userMenuContainer}>
                <Button variant={'secondary'}>
                  <Icon Icon={ArrowDown} width={'17px'} height={'10px'} />
                </Button>
                {User.notifications > 0 && (
                  <div className={classes.indicator} />
                )}
                <div className={classes.userMenu}>
                  <div className={classes.arrow} />
                  <div className={classes.content}>
                    <header>
                      <div
                        className={classes.avatar}
                        style={{
                          backgroundImage: `url(${SmallLogoIcon})`,
                          '--status': User.data.verified
                            ? 'var(--bs-success)'
                            : 'var(--bs-danger)',
                        }}
                      />
                      <div>
                        <p>{User.data.username}</p>
                        <span>
                          {User.data.verified
                            ? t('ვერიფიცირებული')
                            : t('არავერიფიცირებული')}
                        </span>
                      </div>
                    </header>
                    <Stack className={classes.menu}>
                      {tooltipMenu.map((item, index) => (
                        <Link
                          to={item.to}
                          key={item.label}
                          onClick={(e) => {
                            if (e.ctrlKey) return;
                            e.preventDefault();
                            nav.navigate(item.to);
                          }}
                        >
                          <Icon
                            Icon={
                              item.label === 'შეტყობინებები'
                                ? BellIcon
                                : UserMenuIcons
                            }
                            classname={
                              item.label === 'შეტყობინებები'
                                ? classes.bell
                                : null
                            }
                            data-index={index}
                          >
                            {item.label === 'შეტყობინებები' &&
                              User.notifications > 0 && (
                                <Badge bg={'danger'} className={classes.badge}>
                                  {User.notifications}
                                </Badge>
                              )}
                          </Icon>
                          {t(item.label)}
                        </Link>
                      ))}
                    </Stack>
                    <Button variant={'danger'} onClick={() => logout()}>
                      {t('გამოსვლა')}
                    </Button>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <AuthContainer Size={size} classes={classes} />
          )}
          <div className={classes.langWrapper}>
            <div
              className={classes.lang}
              style={{
                backgroundImage: `url(${flags[i18n.language]})`,
              }}
              /*onClick={() => setLang('ka')}*/
            >
              <div className={classes.dropdown}>
                <ul className={classes.list}>
                  {_.map(
                    _.pickBy(flags, (value, key) => key !== i18n.language),
                    (value, key) => (
                      <li
                        key={key}
                        style={{
                          backgroundImage: `url(${value})`,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          langHook.change(key);
                        }}
                      />
                    )
                  )}
                  {/*<li
                    style={{
                      backgroundImage: `url(${RussiaFlag})`,
                    }}
                  />
                  <li
                    style={{
                      backgroundImage: `url(${UkFlag})`,
                    }}
                    onClick={(e) => {
                      //e.preventDefault();
                      e.stopPropagation();
                      setLang('en');
                    }}
                  />*/}
                </ul>
              </div>
            </div>
          </div>
          {/*<Dropdown className={classes.dropdown}>
            <Dropdown.Toggle
              variant="outline-dark"
              id="dropdown-basic"
              className={classes.dropdownSelected}
            >
              <Icon Icon={GeorgiaFlag} width={"25px"} height={"17px"} />
            </Dropdown.Toggle>
            <Dropdown.Menu className={classes.menu} variant="dark">
              <Dropdown.Item href="#" className={classes.item}>
                <Icon Icon={RussiaFlag} width={"25px"} height={"17px"} />
              </Dropdown.Item>
              <Dropdown.Item href="#" className={classes.item}>
                <Icon Icon={UkFlag} width={"25px"} height={"17px"} />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>*/}
        </div>
      </header>
    </Container>
  );
};

export default Header;
